import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'
import { Text } from '@/atoms/Text'

interface Props {
  items: { icon?: ReactNode; content: string | ReactNode; id: string }[]
  className?: string
}
export const DotList: FC<Props> = ({ items, className }) => {
  const lastItemIndex = items.length - 1

  return (
    <div className={classNames('flex items-center gap-[6px] !text-core-gray-400', className)}>
      {items.map(({ icon, content, id }, index) => {
        if (!content) return null

        return (
          <div key={id} className="flex items-center gap-[6px]">
            <div className="flex items-center gap-1">
              {!!icon && icon}

              {typeof content === 'string' ? (
                <Text
                  className="photon-caption-md md:photon-captoin-sm lg:photon-caption-md backdrop-blur-[56px]"
                  color="core-gray-400"
                >
                  {content}
                </Text>
              ) : (
                content
              )}
            </div>

            {index !== lastItemIndex && <div className="h-1 w-1 rounded-full bg-white/30 backdrop-blur-[56px]" />}
          </div>
        )
      })}
    </div>
  )
}
